import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconTikTok = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      className={classes}
      width={width}
      height={height}
      styles={styles}
    >
      <title>TikTok</title>
      <Path
        color={color}
        d='M37.67,8.27l2.43.29c12.22,1.77,21.89,11.75,23.36,24.01.07.58.05,1.23.2,1.79v3.32l-.3,2.41c-1.72,11.46-10.7,20.8-22.07,22.99l-3.61.49h-3.13c-.59-.16-1.27-.12-1.88-.2-12.24-1.48-22.22-11.16-24-23.37l-.29-2.52c.04-1.04-.06-2.1,0-3.13.75-13.96,12.23-25.33,26.17-26.08h3.13ZM42.73,15.37h-6.73v27.51c0,.77-.71,2.34-1.2,2.95-3.91,4.88-11.64,1-9.97-5.19.8-2.96,4.22-4.69,7.12-3.8v-6.91c-6.16-1.04-12.72,3.56-13.89,9.66-.82,4.3.32,8.71,3.52,11.73,7.93,7.49,20.5,2.32,21.24-8.34v-14.42c2.28,1.61,4.99,2.69,7.79,2.95.28.03,1.07.11,1.29.1.1,0,.32-.05.32-.15v-6.68c-4.24.02-8.1-3.04-9.13-7.13-.19-.75-.24-1.51-.36-2.27Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
